import React, { Component } from 'react';
import moment from 'moment';
import { 
    BarChart, 
    Bar, 
    CartesianGrid, 
    Legend,
    Tooltip,
    XAxis, 
    YAxis,
    ResponsiveContainer
} from 'recharts';

const Chart = (props) => {
    const { type, className, data, xAxisType, loading } = props;
    let xAxis, formmattedData, performanceFunction;
    if (xAxisType === 'date') {
        formmattedData = data.reduce((r,i) => {
            r.push({
                ...i,
                date:moment(i.date).valueOf()
            })
            return r
        },[])

        let startDate = moment(data[0].date);
        let endDate = moment(data[data.length-1].date);

        let duration = moment.duration(endDate.diff(startDate));
        let diffDays = duration.asDays();

        let num = 4;
        let current = startDate,
          velocity = Math.round(diffDays / num);
        const ticks = [startDate.valueOf()];
      
        for (let i = 1; i < num; i++) {
          ticks.push(moment(current).add(i*velocity,'days').valueOf());
        }
        
        ticks.push(endDate.valueOf());

        xAxis = <XAxis 
            hasTick
            ticks={ticks}
            dataKey="date"
            scale="date"
            scale="band"
            tickFormatter={v => moment(v).format("D MMM YYYY")}
            />
    } else {
        xAxis = <XAxis/>
    }

    if (loading) {
        return (
            <div className={`${className} card text-center`}>
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <div className={`card`}>
            <ResponsiveContainer width="95%" height={320}>
                <BarChart height={320} width="100%" data={formmattedData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    { xAxis }
                    <YAxis hasTick/>
                    <Legend/>
                    
                    <Tooltip 
                        labelFormatter={(v) => moment(v).format("D MMM YYYY")}
                    />
                    { !type ? <Bar dataKey="quantity" fill="#772DC9" barSize={30} /> : null }
                    { type === "orderPerformance" ? <Bar dataKey="Total" fill="#772DC9"/> : null}
                    
                    { type === "orderPerformance" ? <Bar dataKey="Delay" fill="#00C4B0"/> : null}
                    
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

const data1 = [
    {date: moment().format("YYYY-MM-DD"), quantity: 8},
    {date: moment().add(3,'days').format("YYYY-MM-DD"), quantity: 5},
    {date: moment().add(7,'days').format("YYYY-MM-DD"), quantity: 4}
  ];

  
export default Chart;